<script setup lang="ts">
import { useRouter } from 'vue-router';

import { signOut } from 'aws-amplify/auth';
import { useI18n } from 'vue-i18n';

import { userStore } from '@/store/user';

import { formatName } from '@/utility/format';

const emit = defineEmits(['toggle-sidebar', 'open-customer-overlay']);

const router = useRouter();
const { t } = useI18n();

async function logout() {
  await signOut();
  userStore.loggedIn = false;
  userStore.user = null;
  await router.push({ name: 'Login' });
}

const userInitials = computed(() => {
  if (userStore.user) {
    return userStore.user.firstName.charAt(0) + userStore.user.lastName.charAt(0);
  }
  return '';
});

</script>

<template>
  <div class="layout-header">
    <div class="flex h-full">
      <div class="flex items-center gap-4 w-70 p-2 pl-5">
        <i-button
          data-test="toggle-sidebar"
          severity="transparent"
          :icon="fasBars"
          @click="emit('toggle-sidebar')"
        />

        <img class="layout-header-logo" src="/src/assets/header_logo.svg" alt="Intellivend Logo">
      </div>

      <div class="grow" />

      <div class="flex items-center gap-7 px-8">
        <div class="flex items-center gap-2">
          <p-avatar
            :label="userInitials"
            class="font-bold size-10"
            shape="circle"
          />
          <div>
            <div v-if="userStore.user">
              <div class="font-bold">
                {{ formatName(userStore.user) }}
              </div>
              <div class="text-sm">
                {{ userStore.user?.role?.name }}
              </div>
            </div>
            <span v-else class="font-medium">
              <p-skeleton width="12rem" height="2rem" class="bg-transparent!" />
            </span>
          </div>
        </div>
        <i-button
          v-tooltip.bottom="t('common.logout')"
          data-test="logout-button"
          severity="transparent"
          :icon="farArrowRightFromBracket"
          @click="logout"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.layout-header {
  height: var(--p-layout-header-height);
  background: var(--p-layout-header-background);
  color: #FFF;

  .layout-header-logo {
    height: 2rem;
  }
}

</style>
